export const SUPPORT_PHONE = '913-353-6188'
export const SUPPORT_EMAIL = 'support@freightview.com'
